// src/hooks/usePayments.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for payments management
 * Connects to AppContext for centralized state management
 */
export const usePayments = () => {
    const { state, actions } = useAppContext();

    return {
        // State
        payments: state.payments || [],
        allPayments: state.allPayments || [],
        paymentSubmited: state.paymentSubmited,
        loading: state.loading,
        error: state.error,
        
        // Actions
        fetchPayments: actions.fetchPayments,
        createPayment: actions.createPayment,
        fetchAllPayments: actions.fetchAllPayments,

        // Utility functions
        getPaymentById: (paymentId) => {
            return state.payments?.find(payment => payment.id === paymentId);
        },

        getPaymentsByOwner: (ownerId) => {
            return state.payments?.filter(payment => payment.ownerId === ownerId) || [];
        },

        getPendingPayments: () => {
            return state.payments?.filter(payment => payment.status === 'pending') || [];
        },

        getCompletedPayments: () => {
            return state.payments?.filter(payment => payment.status === 'completed') || [];
        },

        getTotalPayments: () => {
            return state.payments?.reduce((total, payment) => total + (payment.amount || 0), 0) || 0;
        },

        getPaymentCount: () => state.payments?.length || 0,

        searchPayments: (searchTerm) => {
            if (!searchTerm) return state.payments || [];
            const term = searchTerm.toLowerCase();
            return state.payments?.filter(payment => 
                (payment.ownerName && payment.ownerName.toLowerCase().includes(term)) ||
                (payment.reference && payment.reference.toLowerCase().includes(term))
            ) || [];
        }
    };
};

export default usePayments;
